import { createFileRoute } from '@tanstack/react-router';
import { i18next } from '@frontend/i18n';
import { TermsAndConditionsPage } from '../pages';

export const Route = createFileRoute('/legal/terms-conditions_/$locationId')({
  component: TermsAndConditionsPage,
  head: () => ({
    meta: [
      {
        title: i18next.t('Terms & Conditions', { ns: 'digital-forms-experience' }),
      },
    ],
  }),
});
